
export const Index = () => {
  return (
    <div>
      <h1>Export Backups App</h1>
    </div>
  );
}
